import { render, staticRenderFns } from "./contract-list.vue?vue&type=template&id=27f37976&scoped=true"
import script from "./contract-list.vue?vue&type=script&lang=js"
export * from "./contract-list.vue?vue&type=script&lang=js"
import style0 from "./contract-list.vue?vue&type=style&index=0&id=27f37976&prod&scoped=true&lang=scss"
import style1 from "./contract-list.vue?vue&type=style&index=1&id=27f37976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f37976",
  null
  
)

export default component.exports